/**
 * If a Button is inside a menu override it to provide a proper menu
 */
import { createElement as rc } from 'react';
import { MenuItem as _MenuItem, Text, styled } from 'lib_ui-primitives';
import useEventSink from '../../hooks/useEventSink';

const TextLabel = styled(Text)`
    color: ${({ disabled, theme }) => {
        return disabled ? theme.disabledFontColor : theme.defaultFontColor;
    }};
`;

function MenuItem(props) {
    const {
        hNode: { forAction, title, disabled, namespace, relation, type },
        actionPayload = {},
        ...otherProps
    } = props;
    const [, publish] = useEventSink();
    function onClick() {
        publish(actionPayload, { verb: forAction, namespace, relation, type });
    }
    return rc(
        _MenuItem,
        { onClick, disabled: otherProps.disabled ?? disabled, ...otherProps },
        rc(TextLabel, { disabled: otherProps.disabled ?? disabled }, title)
    );
}

export default MenuItem;
